<template>
  <div v-if="view.unreadCount()" class="changelog-badge">
    {{ view.unreadCount() }}
  </div>
</template>

<script setup lang="ts">
import type { ChangelogView } from '@/models/changelog'

defineProps<{
  view: ChangelogView
}>()
</script>

<style lang="scss" scoped>
.changelog-badge {
  text-align: center;
  color: rgb(255, 255, 255);
  font-size: 10px;
  background: rgb(245, 84, 89);
  width: 20px;
  height: 20px;
  border-radius: 20px;
  line-height: 22px;
}
</style>
